<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Analytics
          </h2>

          <small class=" text-muted ">PERFORMANCE </small>
        </div>
        <base-button outline type="success" class="flex" @click="addBanner">
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Export
        </base-button>
      </div>
      <Reports />
      <MIS />
      <div></div>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";
import MIS from "./components/MIS";
import Reports from "./components/Reports";
export default {
  data() {
    return {};
  },
  components: {
    Reports,
    MIS
  }
};
</script>
<style>
.nav-pills-w > div > .nav-pills li {
  width: 30%;
  text-align: center;
}
.nav-pills-w > div > .nav-pills {
  justify-content: start;
}
.nav-pills-w > div > .nav-pills li a {
  font-weight: 700;
}
</style>
